import { File } from '../file';
import { InternHeadline } from '../intern/headline';
import { InternIconLink } from '../intern/icon-link';

/**
 * Model definition for Avatar
 */
export interface ContentAvatar {
  __component: 'content.avatar';
  id: string;
  image?: File;
  headline: InternHeadline[];
  text?: string;
  subline?: string;
  actions: InternIconLink[];
  layout: 'default' | 'contact';
}

export function isContentAvatar(obj: { __component?: string }): obj is ContentAvatar {
  return obj.__component === 'content.avatar';
}
